import { useMutation } from '@tanstack/react-query';
import {
  BulkConversationPassthroughCreateParams,
  BulkOperationResponse,
  V1ConversationsService,
} from 'src/api/generated';

interface UseBulkCreateConversationsParams {
  onSuccess?: (data: BulkOperationResponse) => void;
  onError?: (error: Error) => void;
}

interface UseBulkCreateConversationsResponse {
  loading: boolean;
  error: Error | null;
  result: BulkOperationResponse | null;
  createBulkConversations: (
    data: BulkConversationPassthroughCreateParams
  ) => Promise<BulkOperationResponse>;
}

/**
 * Hook for creating bulk conversations
 */
export const useBulkCreateConversations = ({
  onSuccess = () => {},
  onError = () => {},
}: UseBulkCreateConversationsParams = {}): UseBulkCreateConversationsResponse => {
  const createBulkConversations = async (
    data: BulkConversationPassthroughCreateParams
  ): Promise<BulkOperationResponse> => {
    return await V1ConversationsService.bulkCreate(data);
  };

  const mutation = useMutation({
    mutationFn: createBulkConversations,
    onSuccess: (data: BulkOperationResponse) => {
      onSuccess(data);
    },
    onError: (error: Error) => onError(error),
  });

  return {
    loading: mutation.isPending,
    error: mutation.error,
    result: mutation.data || null,
    createBulkConversations: mutation.mutateAsync,
  };
};
